import { appleAppStoreUrl, googlePlayStoreUrl } from './urls';

export const appStoreLinks = {
  android: googlePlayStoreUrl,
  ios: appleAppStoreUrl,
} satisfies Record<MobilePlatform, string>;
